<template>
  <div class="item-main">
    <div class="title">
      Trend Chart
    </div>
    <div
      class="form"
      :style="{
        'flex-direction': !isDesktop && 'column',
        'align-items': !isDesktop && 'start',
      }"
    >
      <ActivitySelector
        v-model:value="query.activityId"
        @change="getData"
      ></ActivitySelector>
      <DateRangePicker
        @change="onDateChange"
        :style="{
          'margin-top': !isDesktop && '8px',
        }"
      ></DateRangePicker>
    </div>
    <a-spin :spinning="spinning">
      <div v-if="query.activityId" ref="trendChart2" id="trend-chart2"></div>

      <div v-else class="default-chart">
        <img src="../../../assets/statistics/bar_chart_default.svg" alt="" />
      </div>
    </a-spin>
  </div>
</template>

<script>
import ActivitySelector from '@/components/ActivitySelector'
import DateRangePicker from '@/components/DateRangePicker'
import { yDataFormat2 } from '@/utils/yDataFormat'
import echarts from 'echarts'

const chartTheme = require('@/styles/chart_theme/macarons.json')
let chart = undefined
let chartData = undefined

const legend = [
  'New Registrations',
  'New Real Traders',
  'Qualified Real Traders',
]
const legendField = [
  'newRegistrations',
  'newRealTraders',
  'qualifiedRealTraders',
]

export default {
  name: 'TrendChart1',
  components: { ActivitySelector, DateRangePicker },
  mounted() {
    const id = this.$store.state.link.defaultActivityId
    if (id) {
      this.query.activityId = id
      this.getData()
    }
  },
  computed: {
    defaultActivityId() {
      return this.$store.state.link.defaultActivityId
    },
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  watch: {
    defaultActivityId() {
      this.query.activityId = this.defaultActivityId
      this.getData()
    },
  },
  data() {
    return {
      query: {
        activityId: undefined,
        createTimeBegin: undefined,
        createTimeEnd: undefined,
      },
      YMDDateList: undefined,
      xData: undefined,
      series: undefined,
      spinning: false,
    }
  },
  methods: {
    getData() {
      if (!this.query.activityId) return
      this.spinning = !this.spinning
      this.$store
        .dispatch('statistics/GetTrendChart2', this.query)
        .then((res) => {
          const i = yDataFormat2(res, legend, legendField)
          chartData = res
          this.series = i.series
          this.xData = i.xData
          this.initChart()
        })
        .finally(() => {
          this.spinning = !this.spinning
        })
    },
    onDateChange(beginTime, endTime) {
      this.query.createTimeBegin = beginTime
      this.query.createTimeEnd = endTime
      this.getData()
    },
    initChart() {
      echarts.registerTheme('macarons', chartTheme)
      chart = echarts.init(this.$refs.trendChart2, 'macarons')
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          data: legend,
          itemWidth: 20,
          itemHeight: 10,
          type: 'scroll',
        },
        xAxis: {
          type: 'category',
          data: this.xData,
          axisLabel: {
            interval: 0,
            rotate: 45,
            formatter: function(v) {
              return v.length > 10 ? v.substr(0, 9) + '...' : v
            },
          },
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
        },
        series: this.series,
      }
      chart.setOption(option)
      chart.on('legendselectchanged', function(params) {
        const i = yDataFormat2(
          [...chartData],
          legend,
          legendField,
          params.selected,
        )
        option.series = i.series
        option.xAxis.data = i.xData
        chart.setOption(option)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#trend-chart2 {
  margin-top: 20px;
  width: 100%;
  height: 300px;
}
</style>
